export const constants = {
  v24111: 'https://rappit-dev.rappit.io',
  v24031: 'https://rappit-dev.rappit.io/v24031',
  v23121: 'https://eva-design-studio-test-vkmhkpuxwq-ez.a.run.app'
};
